/**
 * Epic Status Configuration
 *
 * Single source of truth for epic status/phase column definitions.
 * This file defines the visual appearance and properties of each phase column
 * in the epics Kanban board.
 */

import { EpicStatus } from 'shared/types/epic';

export interface EpicPhaseColumn {
  id: EpicStatus;
  label: string;
  color: string;
  bgColor: string;
  headerBgColor: string;
  borderColor: string;
}

/**
 * Epic Phase Columns
 * Defines all available epic status columns with their styling
 */
export const epicPhaseColumns: EpicPhaseColumn[] = [
  {
    id: EpicStatus.PLANNING,
    label: 'Planning',
    color: 'text-blue-700',
    bgColor: 'bg-blue-50/50',
    headerBgColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
  },
  {
    id: EpicStatus.IN_PROGRESS,
    label: 'In Behandeling',
    color: 'text-moss-primary',
    bgColor: 'bg-moss-primary/5',
    headerBgColor: 'bg-moss-primary/10',
    borderColor: 'border-moss-primary/20',
  },
  {
    id: EpicStatus.COMPLETED,
    label: 'Afgerond',
    color: 'text-status-good',
    bgColor: 'bg-status-good/5',
    headerBgColor: 'bg-status-good/10',
    borderColor: 'border-status-good/20',
  },
  {
    id: EpicStatus.ON_HOLD,
    label: 'On Hold',
    color: 'text-orange-700',
    bgColor: 'bg-orange-50/50',
    headerBgColor: 'bg-orange-50',
    borderColor: 'border-orange-200',
  },
];
